import { IComponentOptions } from "angular";
import { MachineDetailComponentController } from "./controller";

export const vsComponentName = "machineDetail";

export const machineDetailComponentOptions: IComponentOptions = {
  controller: MachineDetailComponentController,
  controllerAs: "machineDetailComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "=",
  },
  transclude: {
    expandedView: "expandedView",
    shortView: "?shortView",
  },
};
